<template>
  <br>
  <div>
    <button class="light-button" @click="clickHandler">Datasets</button>
    <ListView :items="itemList" @item-clicked="handleItemClicked" />
  </div>
</template>

<script setup>

import { onMounted, ref, inject } from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ListView from '@/components/utils/ListView.vue';
import { useRouter } from 'vue-router';

const emit = defineEmits(['card_updated']);
const props = defineProps({ projectID: Number });
const isPublic = inject('isPublic', false);
const itemList = ref([]);
const router = useRouter();

function clickHandler() {
  router.push({ name: `${isPublic ? 'public.' : ''}datasets`, params: { projectId: props.projectID } });
}

onMounted(async () => {
  getDatasets();
});

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
}

async function getDatasets() {
  const dataConnect = new DatastoreConnect();
  const result = await dataConnect.getDatasetList({ project_id: props.projectID })
    .then(async (data) => {
      if (!data.result) {

      } else {
        const datasets = data.result;
        itemList.value = [];

        for (let k = 0; k < datasets.length; k++) {
          const item = {};
          item.url = `/${props.projectID}/datasets/gallery/main?dataset=${datasets[k].id}`;
          item.id = `ds-${datasets[k].id.toString(16)}`;
          item.dataset_id = datasets[k].id;
          item.name = datasets[k].name;
          item.createdAt = formatDate(datasets[k].createdAt);
          item.description = datasets[k].description;
          itemList.value.push(item);
        }
      }
    })
    .catch((error) => {

    });
}

function handleItemClicked(item) {
  router.push({
    name: `${isPublic ? 'public.' : ''}datasets.gallery.main`,
    params: {
      projectId: props.projectID,
    },
    query: {
      dataset: item.dataset_id,
    },
  });
}

</script>

<style lang="scss" scoped>

</style>
